import Vue from 'vue';

Vue.directive('stop-click', {
	// When the bound element is inserted into the DOM...
	inserted(el) {
		el.addEventListener('click', event => event.stopPropagation());
	}
});
